export default __webpack_public_path__ + "static/media/logo_full_text.99b3630e.svg";